// actions.js
import axios from 'axios';

// Action types
export const UPLOAD_DATA_SUCCESS = 'UPLOAD_DATA_SUCCESS';
export const FETCH_PROCESS_DATA = 'FETCH_PROCESS_DATA';
export const FETCH_UPLOADSTATUS_DATA = 'FETCH_UPLOADSTATUS_DATA';



export const PostBulkUpload = (data) => ({
  type: UPLOAD_DATA_SUCCESS,
  payload: data
});


export const FetchProcessData = (data) => ({
  type: FETCH_PROCESS_DATA,
  payload: data
})

export const FetchStatusUpload = (data) => ({
  type: FETCH_UPLOADSTATUS_DATA,
  payload:data
})